import { createUseFetch } from '../../../hooks/use-fetch'
import { chiliService, downloadsService } from '../../../services'
import { fromState } from '../../../utils'

export const useTemplates = fromState([])

export const chiliFetch = createUseFetch(chiliService)
export const downloadFetch = createUseFetch(downloadsService)
